import { Form, Input, Modal } from "antd";
import { useForm } from "antd/es/form/Form";
import React, { useState } from "react";
import { IAccountCreate, IChangePassword } from "../../../../models/account";
import { changePasswordAccount } from "../../../../apis/account";
import { ErrorPopup } from "../../../../utilities/swal";

interface ModalChangePasswordProps {
  visible: boolean;
  onClose: () => void;
  accountId: string;
}

const ModalChangePassword: React.FC<ModalChangePasswordProps> = (
  props: ModalChangePasswordProps
) => {
  const { visible, onClose, accountId } = props;

  const [loading, setLoading] = useState(false);
  const [form] = useForm();
  const onFinish = async (values: any) => {
    setLoading(true);
    try {
      const rs = await changePasswordAccount(accountId, {
        currentPassword: values.currentPassword,
        newPassword: values.newPassword,
      });
      if (rs && rs.success) {
        form.resetFields();

        onClose && onClose();
      } else {
        ErrorPopup("Đổi mật khẩu thất bại", rs?.message || "");
      }
    } catch (error: any) {
      ErrorPopup("Đổi mật khẩu thất bại", error?.message || "");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal
      title="Đổi mật khẩu"
      open={visible}
      onCancel={onClose}
      onOk={() => form.submit()}
      confirmLoading={loading}
    >
      <Form<IChangePassword>
        disabled={loading}
        layout="vertical"
        form={form}
        onFinish={onFinish}
        autoComplete="off"
        className="mt-3"
      >
        {/* Mật khẩu cũ */}
        <Form.Item<IChangePassword>
          label="Mật khẩu cũ"
          name="currentPassword"
          rules={[{ required: true, message: "Mời điền mật khẩu cũ" }]}
        >
          <Input.Password placeholder="Nhập mật khẩu cũ" />
        </Form.Item>

        {/* Mật khẩu mới */}
        <Form.Item<IChangePassword>
          label="Mật khẩu mới"
          name="newPassword"
          rules={[
            { required: true, message: "Mời điền mật khẩu mới" },
            { min: 8, message: "Mật khẩu phải có ít nhất 8 ký tự" },
          ]}
        >
          <Input.Password placeholder="Nhập mật khẩu mới" />
        </Form.Item>

        {/* Nhập lại mật khẩu mới */}
        <Form.Item
          label="Nhập lại mật khẩu mới"
          name="confirmPassword"
          dependencies={["newPassword"]}
          rules={[
            { required: true, message: "Vui lòng nhập lại mật khẩu" },
            ({ getFieldValue }) => ({
              validator(_, value) {
                if (!value || getFieldValue("newPassword") === value) {
                  return Promise.resolve();
                }
                return Promise.reject(
                  new Error("Mật khẩu nhập lại không khớp")
                );
              },
            }),
          ]}
        >
          <Input.Password placeholder="Nhập lại mật khẩu mới" />
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default ModalChangePassword;
